<!-- <div *ngIf="loading">
     <i class="fas fa-spinner fa-spin estiloSpinner"></i>
</div> -->

<div class="">
     <table mat-table [dataSource]="dataSource">

          <!-- Position Column -->
          <ng-container matColumnDef="type">
               <th mat-header-cell *matHeaderCellDef> Tipo </th>
               <td mat-cell *matCellDef="let element"> {{element.type}} </td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="skill">
               <th mat-header-cell *matHeaderCellDef> Dirigido </th>
               <td mat-cell *matCellDef="let element"> {{element.skill}} </td>
          </ng-container>

          <!-- Weight Column -->
          <ng-container matColumnDef="date">
               <th mat-header-cell *matHeaderCellDef> Fecha </th>
               <td mat-cell *matCellDef="let element"> {{element.date}} </td>
          </ng-container>

          <ng-container matColumnDef="rut">
               <th mat-header-cell *matHeaderCellDef> RUT </th>
               <td mat-cell *matCellDef="let element"> {{element.rut}} </td>
          </ng-container>

          <ng-container matColumnDef="name">
               <th mat-header-cell *matHeaderCellDef> Nombre </th>
               <td mat-cell *matCellDef="let element"> {{element.name}} </td>
          </ng-container>

          <!-- Symbol Column -->
          <ng-container matColumnDef="comment">
               <th mat-header-cell *matHeaderCellDef> Observación </th>
               <td mat-cell *matCellDef="let element"> {{element.comment}} </td>
          </ng-container>

          <ng-container matColumnDef="can_edit_callback">
               <th mat-header-cell *matHeaderCellDef> Acciones </th>
               <td mat-cell *matCellDef="let element">
                    <button *ngIf="element.can_edit_callback" class="btn btn-primary btn-sm" (click)="editCallback(element)">
                         <i class="fas fa-edit"></i>
                    </button>
               </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
     </table>

     <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons aria-label="Select page of periodic elements">
     </mat-paginator>
</div>